import template from './blank.html';
import controller from './blank.controller';
import './slider.css';

let blankComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default blankComponent;



// WEBPACK FOOTER //
// ./client/app/components/blank/blank.component.js